import {Component, OnInit} from '@angular/core';
import {Product} from "../../models/product";
import {ShopService} from "../../modules/shop/service/shop.service";
import {FREE_DELIVERY_THRESHOLD} from "../../services/util/constants";

/**
 * First screen of the home page: the best-selling product with its current price and a
 * button straight to it. The old slideshow showed a slogan and a business-opportunity slide,
 * and nothing a visitor could buy.
 */
@Component({
    selector: 'app-hero-section',
    templateUrl: './hero-section.component.html',
    styleUrls: ['./hero-section.component.css'],
})
export class HeroSectionComponent implements OnInit {

    /** Shown until the best seller loads - the aloe vera gel has been the best seller from the start. */
    readonly fallbackImage = '/assets/images/aloe-vera-pijaloci/aloe-vera-gel-forever.webp';

    readonly freeDeliveryThreshold = FREE_DELIVERY_THRESHOLD;

    product: Product | null = null;

    constructor(private readonly shopService: ShopService) {
    }

    ngOnInit(): void {
        this.shopService.getTopSellingProducts(1).subscribe({
            next: products => this.product = products[0] ?? null,
            error: () => this.product = null
        });
    }

    /** "Алое вера гел за пиење | Forever Aloe Vera Gel 1 л" -> the Macedonian half, short enough for a phone. */
    get headline(): string {
        const name = this.product?.name ?? 'Алое вера гел за пиење';
        return name.split('|')[0].trim();
    }

    get productUrl(): string {
        if (!this.product) {
            return '/shop/aloe-vera-pijaloci';
        }
        return '/shop/product/' + (this.product.slug ? this.product.slug + '-' + this.product.id : this.product.id);
    }

    get discountPercent(): number {
        return Math.round(this.product?.discount?.discountPercentage ?? 0);
    }
}
